import React from 'react';

function Curacao(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124155)">
        <mask
          id="mask0_800_124155"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124155)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#2E42A5"
          />
          <mask
            id="mask1_800_124155"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124155)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.78623 6.14923L2.54877 7.19891L3.62907 5.33053L2.25 3.96315L3.96376 3.90693L4.78623 2L5.41387 3.90693L7.41934 3.96315L5.97541 5.33053L6.89143 7.19891L4.78623 6.14923Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.7712 11.0766L10.0097 12.1048L11.0931 9.52818L8.69214 7.7993H11.5691L12.7712 5.01221L13.6885 7.7993H16.5699L14.5224 9.52818L15.5391 12.1048L12.7712 11.0766Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 14V18H36V14H0Z"
              fill="#F9E813"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124155">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Curacao;
